import { Link } from "react-router-dom";
import { Phone, MessageCircle, CalendarCheck, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { CLINIC, telLink, whatsappLink } from "../data/site";

export const AppointmentSection = () => (
  <section className="relative overflow-hidden bg-dash-ink py-24 md:py-32" data-testid="appointment-cta">
    <div className="grain" />
    {/* ambient shapes */}
    <div className="pointer-events-none absolute -top-24 -right-24 h-96 w-96 rounded-full bg-dash-teal/20 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-32 -left-20 h-96 w-96 rounded-full bg-dash-indigo/20 blur-3xl" />

    <div className="relative mx-auto max-w-4xl px-5 sm:px-8 text-center">
      <Reveal>
        <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] font-accent font-semibold text-dash-gold">
          <span className="h-px w-8 bg-dash-gold/60" /> Appointments
        </span>
      </Reveal>
      <Reveal delay={0.05}>
        <h2 className="mt-6 font-display text-4xl md:text-6xl font-bold text-white leading-[1.05] text-balance">
          Ready to Take the Next Step?
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mt-6 text-lg text-white/70 max-w-2xl mx-auto">
          Contact DASH Physiotherapy &amp; Speech and Hearing Clinic to schedule an appointment.
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href={telLink} data-testid="cta-call" className="group w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-white text-dash-ink px-7 py-4 font-semibold hover:-translate-y-0.5 transition-transform duration-300">
            <Phone className="h-5 w-5 text-dash-teal" /> Call Now
          </a>
          <a href={whatsappLink()} target="_blank" rel="noreferrer" data-testid="cta-whatsapp" className="group w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-[#25D366] text-white px-7 py-4 font-semibold hover:-translate-y-0.5 transition-transform duration-300">
            <MessageCircle className="h-5 w-5" /> WhatsApp Us
          </a>
          <Link to="/contact" data-testid="cta-book" className="group w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-dash-teal text-white px-7 py-4 font-semibold hover:-translate-y-0.5 transition-transform duration-300">
            <CalendarCheck className="h-5 w-5" /> Book an Appointment
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>
      </Reveal>

      <Reveal delay={0.2}>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-8 gap-y-2 text-white/60 text-sm">
          <span>Phone: <a href={telLink} className="text-white font-medium hover:text-dash-teal">{CLINIC.phone}</a></span>
          <span className="hidden sm:inline text-white/20">|</span>
          <span>WhatsApp: <a href={whatsappLink()} target="_blank" rel="noreferrer" className="text-white font-medium hover:text-dash-teal">{CLINIC.whatsapp}</a></span>
        </div>
      </Reveal>
    </div>
  </section>
);
